/**
 *  用户相关 API 地址
 *  @swagger http://bp-company-cert-bff.t-sy-in.earth.xcloud.lenovo.com/swagger-ui.html
 */
import { IAjaxConfig } from '../helpers';
export class EnumApiCompany {
  /**
   * @dec post 企业认证 - token 获取企业认证信息
   */
  readonly company_auth_token: IAjaxConfig = {
    url: '/api/gateway/company-cert-bff/api/partnerVerified/token',
    method: 'post',
    loading: false,
    awaitAuthenticated: true,
  };

  /**
   * @dec post 企业认证 - 相关认证状态
   */
  readonly company_auth_authentication: IAjaxConfig = {
    url: '/api/gateway/company-cert-bff/api/authentication/status/token',
    method: 'get',
    loading: true,
    awaitAuthenticated: true,
  };
}
